import './CategoryCampaigns.css';

import { IonContent, IonPage, IonRow, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react';
import { useEffect, useState } from 'react';
import { RouteComponentProps } from 'react-router';

import CampaignItem from '../../components/campaign/CampaignItem';
import ContentSpinner from '../../components/loading/ContentSpinner';
import LoadingContainer from '../../components/loading/LoadingContainer';
import LayoutGap from '../../layouts/LayoutGap';
import Toolbar from '../../layouts/Toolbar';
import { CategoryCampaignsAction } from '../../redux/actions/Home';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { arrayIsEmpty, objIsEmpty } from '../../library/Funcs';

interface Props extends RouteComponentProps<{
  category_id: string,
}> { }

const CategoryCampaigns: React.FC<Props> = ({ match }) => {
  const dispatch = useAppDispatch();

  // const [categoryData, setCategoryData] = useState({ event: null as any, currentPage: 0 });
  const { loading, campaigns } = useAppSelector(state => state.categoryCampaignsGet)
  // const [categoryCampaigns, setCategoryCampaigns] = useState([] as any);

  useEffect(() => {
    // dispatch(CategoryCampaignsAction(match.params.category_id, categoryData.currentPage))
    if (objIsEmpty(campaigns) || campaigns.category_id != match.params.category_id) {
      dispatch(CategoryCampaignsAction(match.params.category_id))
    }
  }, [dispatch, match.params.category_id])

  // useEffect(() => {
  //   if (campaigns != null && !loading) {
  //     categoryData.event?.target.complete();

  //     const items = categoryCampaigns.concat(campaigns.activeProjects);

  //     if (categoryData.event?.target != null)
  //       categoryData.event.target.disabled = (items.length == campaigns.activeProjectsTotal);

  //     setCategoryCampaigns(items);
  //   }
  // }, [loading])

  // const loadMoreHandler = (e: any) => {
  //   const currentPage = categoryData.currentPage + 1

  //   setCategoryData({ event: e, currentPage: currentPage })
  // }

  return <LoadingContainer loading={loading}>
    <IonPage>
      <Toolbar title={campaigns?.category_name} hasBackButton />

      <LayoutGap />

      <IonContent className="main-content">
        {/* <ContentSpinner loadData={loadMoreHandler}> */}
          <IonRow>
            {campaigns.activeProjects?.map((item: any) => {
              return <CampaignItem
                type="normal"
                key={`campaign_${item.id}`}
                link={`/campaign/${item.id}`}
                id={item.id}
                title={item.title}
                image={item.image}
                location={item.province}
                date={item.date}
                currentPrice={item.donates}
                targetPrice={item.goal}
                progress={item.percentage}
                finalized={item.finalized}
                hideButton={true} />
            })}
          </IonRow>
        {/* </ContentSpinner> */}
      </IonContent>
    </IonPage>
  </LoadingContainer>
}

export default CategoryCampaigns